import pageStyle from "./index.module.less";
import * as service from "../../service";

export default {
    name: "SelectTicketType",
    data() {
        return {
            options: [],
            pageStyle
        };
    },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: Number,
        placeholder: {
            type: String,
            default: null
        }
    },
    created() {
        this.getSeletData();
    },
    methods: {
        async getSeletData() {
            const { list } = await service.listType(),
                listParent = {};
            list.forEach(value => {
                if (value.pid == 0) {
                    if (!listParent[value.id]) {
                        listParent[value.id] = {
                            label: value.name,
                            value: value.id,
                            children: []
                        };
                    } else {
                        listParent[value.id].label = value.name;
                    }
                }

                if (value.pid != 0) {
                    if (listParent[value.pid]) {
                        listParent[value.pid].children.push({
                            label: value.name,
                            value: value.id
                        });
                    } else {
                        listParent[value.pid] = {
                            value: value.pid,
                            children: [
                                {
                                    label: value.name,
                                    value: value.id
                                }
                            ]
                        };
                    }
                }
            });

            this.options = Object.keys(listParent).map(value => {
                return listParent[value];
            });
        },

        onChange(value) {
            const result = value[value.length - 1];
            this.$emit("change", result);
        }
    }
};
